import { register } from "ol/proj/proj4";
import proj4 from "proj4";
/**
 * Loads a projection definition from epsg.io and registers it in proj4 and ol.
 *
 * @param epsg Projection to load in format 'EPSG:32633'
 * @returns Promise
 */
export default async function loadProjection(epsg) {
    return new Promise((resolve, reject) => {
        const code = epsg.split(":")[1];
        fetch(`https://epsg.io/${code}.proj4`)
            .then((res) => res.text())
            .then((def) => {
            proj4.defs(epsg, def);
            register(proj4);
            resolve(def);
        })
            .catch((err) => {
            console.error("Could not load projection.", epsg, err);
            reject(err);
        });
    });
}
